import { render, staticRenderFns } from "./BaseTopTabs.vue?vue&type=template&id=c826e5d8&scoped=true"
import script from "./BaseTopTabs.vue?vue&type=script&lang=js"
export * from "./BaseTopTabs.vue?vue&type=script&lang=js"
import style0 from "./BaseTopTabs.vue?vue&type=style&index=0&id=c826e5d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c826e5d8",
  null
  
)

export default component.exports